import React, { useState, useEffect } from 'react'
import { Phone, Mail, MapPin, Clock } from 'lucide-react'
import useIntersectionObserver from '../hooks/useIntersectionObserver'

function ContactPage() {
  const [heroVisible, setHeroVisible] = useState(false)

  // Animasyon için intersection observer'lar
  const [contactInfoRef, contactInfoVisible] = useIntersectionObserver()

  // Hero section için animasyon
  useEffect(() => {
    const timer = setTimeout(() => {
      setHeroVisible(true)
    }, 300)
    return () => clearTimeout(timer)
  }, [])
  const contactInfo = [
    {
      icon: Phone,
      title: 'Telefon',
      details: ['+90 (533) 400 9199'],
      description: 'Hafta içi 09:00 - 18:00'
    },
    {
      icon: Mail,
      title: 'E-posta',
      details: ['alicnszz1983@gmail.com'],
      description: 'Size en kısa sürede dönüş yapıyoruz'
    },
    {
      icon: MapPin,
      title: 'Adres',
      details: ['OSB 2.Organize Sanayi Bolgesi', 'Şehitkamil / Gaziantep'],
      description: 'Ziyaret saatleri: 09:00 - 18:00'
    },
    {
      icon: Clock,
      title: 'Çalışma Saatleri',
      details: ['Pazartesi - Cumartesi: 08:00 - 18:00'],
      description: 'Pazar kapalı'
    }
  ]

  return (
    <div>
      {/* Hero Section */}
      <section className="relative h-96 flex items-center text-white overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url("/foto/fab3.jpg")'
          }}
        ></div>
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>
        
        {/* Content */}
        <div className="relative container-custom z-10">
          <div className="max-w-4xl">
         
          </div>
        </div>
      </section>

      <div className="py-12 bg-gray-50">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            {/* Contact Information */}
            <div ref={contactInfoRef} className={`bg-white p-8 rounded-2xl shadow-lg mb-8 fade-in ${contactInfoVisible ? 'visible' : ''}`}>
              <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">
                İletişim Bilgileri
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {contactInfo.map((info, index) => {
                  const Icon = info.icon
                  return (
                    <div 
                      key={index} 
                      className={`flex items-start space-x-4 slide-up ${contactInfoVisible ? 'visible' : ''}`}
                      style={{ transitionDelay: `${index * 0.2}s` }}
                    >
                      <div className="bg-primary-100 p-3 rounded-lg">
                        <Icon className="text-primary-600" size={24} />
                      </div>
                      <div className="flex-1">
                        <h3 className="font-semibold text-gray-900 mb-2">
                          {info.title}
                        </h3>
                        {info.details.map((detail, idx) => (
                          <p key={idx} className="text-gray-600 mb-1">
                            {detail}
                          </p>
                        ))}
                        <p className="text-sm text-gray-500">
                          {info.description}
                        </p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactPage